// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json = require("../../../shared/src/Json.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Apollo = require("../../../shared/src/bindings/Apollo.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var CommonTypes_City = require("../../../shared/src/types/CommonTypes_City.bs.js");

var Raw = {};

var query = "query   {\ncities(filter: {disabledAt: {isNull: true}, launchedAt: {isNull: false}})  {\nnodes  {\n...CommonTypes_City   \n}\n\n}\n\n}\n" + CommonTypes_City.query;

function parse(value) {
  var value$1 = value.cities;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.nodes;
    tmp = {
      nodes: value$2.map(function (value) {
            if (!(value == null)) {
              return CommonTypes_City.verifyArgsAndParse("CommonTypes_City", value);
            }
            
          })
    };
  }
  return {
          cities: tmp
        };
}

function serialize(value) {
  var value$1 = value.cities;
  var cities;
  if (value$1 !== undefined) {
    var value$2 = value$1.nodes;
    var nodes = value$2.map(function (value) {
          if (value !== undefined) {
            return CommonTypes_City.serialize(value);
          } else {
            return null;
          }
        });
    cities = {
      nodes: nodes
    };
  } else {
    cities = null;
  }
  return {
          cities: cities
        };
}

function serializeVariables(param) {
  
}

function makeVariables(param) {
  
}

function makeDefaultVariables(param) {
  
}

function variables(param) {
  return Json.Encode.object_(/* [] */0);
}

function decode(param) {
  var match = param.cities;
  if (match !== undefined) {
    return Relude_Option.pure(Curry._1(CommonTypes_City.$$Set.fromArray, Relude_Array.mapOption((function (param) {
                          return Relude_Option.map(CommonTypes_City.tToR, param);
                        }), match.nodes)));
  }
  
}

var Definition = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  makeDefaultVariables: makeDefaultVariables,
  variables: variables,
  decode: decode
};

var include = Apollo.CreateQuery({
      Raw: Raw,
      query: query,
      variables: variables,
      parse: parse,
      decode: decode
    });

var Launched_graphqlQueryAST = include.graphqlQueryAST;

var Launched_query = include.query;

var Launched_queryStoreError = include.queryStoreError;

var Launched_queryResult = include.queryResult;

var Launched_queryAsyncData = include.queryAsyncData;

var Launched_queryAsyncDataStoreError = include.queryAsyncDataStoreError;

var Launched_queryAsyncResult = include.queryAsyncResult;

var Launched = {
  Definition: Definition,
  graphqlQueryAST: Launched_graphqlQueryAST,
  query: Launched_query,
  queryStoreError: Launched_queryStoreError,
  queryResult: Launched_queryResult,
  queryAsyncData: Launched_queryAsyncData,
  queryAsyncDataStoreError: Launched_queryAsyncDataStoreError,
  queryAsyncResult: Launched_queryAsyncResult
};

exports.Launched = Launched;
/* include Not a pure module */
